import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductTransactions14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_183)'>
      <path d='M6 4.75V3.25H8V4.75H6Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7ZM3.25001 3.32576C2.32211 4.27266 1.75 5.56952 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 5.56952 11.6779 4.27267 10.75 3.32576C10.75 5.09155 10.8011 6.86583 10.7497 8.63076C10.7264 9.43128 9.81832 10.0857 9.10884 9.53632L7.012 7.91277L4.91702 9.53489C4.18649 10.1061 3.2476 9.4511 3.25001 8.60766V3.32576ZM4.75001 2.25522V7.76712L6.39223 6.49557C6.75374 6.20874 7.27028 6.20874 7.63178 6.49557L9.25 7.74854V2.25522C8.56806 1.93127 7.8052 1.75 7 1.75C6.1948 1.75 5.43195 1.93127 4.75001 2.25522Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_183'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductTransactions14.displayName = 'ProductTransactions14';
export default ProductTransactions14;
